import { ValidationErrors } from 'final-form';
import { PropsWithChildren } from 'react';
import { Form } from 'react-final-form';

import { SubmitFormValues } from '../../../interfaces';
import { useSubmitFormData } from '../../../libs/hooks';
import { HiddenInputComponent } from '../../dsfr';
import { SimpleButton } from '../buttons';
import { FormErrorComponent } from '../form-error';
import { FormErrorScrollComponent } from '../form-error-scroll';
import { MentionsComponent } from '../mentions';
import { FormHeaderComponent } from './header';
import { RequiredMessageComponent } from './required';

interface FormWrapperComponentProps<T> {
  onValidate?: (values: SubmitFormValues) => ValidationErrors;
  initialValues?: T;
  decorators?: any[];
  title?: string;
}

export function FormWrapperComponent<FormValues>({
  children,
  decorators,
  initialValues,
  onValidate,
  title = 'Formulaire de contact',
}: PropsWithChildren<FormWrapperComponentProps<FormValues>>) {
  const { submitDataForm } = useSubmitFormData();

  return (
    <Form
      decorators={decorators}
      initialValues={initialValues}
      validate={onValidate}
      onSubmit={submitDataForm}>
      {({ handleSubmit, submitError, submitting }) => (
        <form noValidate id="form" onSubmit={handleSubmit}>
          <FormHeaderComponent title={title} />
          <div>
            <RequiredMessageComponent />
            <HiddenInputComponent name="platform" />
            <HiddenInputComponent name="formName" />
            <HiddenInputComponent name="formType" />
            {children}
          </div>
          <div className="fc-text--center fr-mt-4w fr-mb-6w">
            <SimpleButton disabled={submitting} label="Envoyer ces informations" />
          </div>
          <FormErrorComponent error={submitError} />
          <MentionsComponent />
          <FormErrorScrollComponent />
        </form>
      )}
    </Form>
  );
}

FormWrapperComponent.displayName = 'FormWrapperComponent';
